import Navbar from "./Navbar";
import "./CareerPage.css";
import React, { useState, useEffect, useRef } from "react";
import * as amplitude from "@amplitude/unified";
// import axios from "axios";


export default function CareerPage() {
  // const benefits = [
  //   "Competitive salary and performance bonuses",
  //   "Comprehensive health, dental, and vision insurance",
  //   "Professional development opportunities",
  //   "Flexible work arrangements",
  //   "Employee wellness programs",
  //   "Team building events and activities",
  // ];

  const lifeImages = [
    "/images/life1.jpg",
    "/images/life3.jpg",
    "/images/life2.jpg",
  ];
  const [currentSlide, setCurrentSlide] = useState(0);
  const [lightbox, setLightbox] = useState(null);
  const slideTimer = useRef(null);

  useEffect(() => {
    slideTimer.current = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % lifeImages.length);
    }, 3500);
    return () => clearInterval(slideTimer.current);
  }, [lifeImages.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
    clearInterval(slideTimer.current);
    slideTimer.current = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % lifeImages.length);
    }, 3500);
  };

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    jobTitle: "",
    experience: "",
    skills: "",
    education: "",
    additional: "",
  });

  const handleApplyClick = (jobTitle) => {
    setFormData((prev) => ({ ...prev, jobTitle }));
    amplitude.track("Job Application Started", { job_title: jobTitle });
    document.getElementById("resume-form-section")?.scrollIntoView({ behavior: "smooth" });
  };

  
  const [file, setFile] = useState(null);
  const [message] = useState("");
  const [loading, setLoading] = useState(false); 
  const [successMessage, setSuccessMessage] = useState("");
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const form = new FormData();

    form.append("name", `${formData.firstName} ${formData.lastName}`);
    form.append("email", formData.email);
    form.append("phone", formData.phone);
    form.append("subject", `Resume Submission: ${formData.jobTitle}`);
    form.append(
      "message",
      `Experience: ${formData.experience}\nSkills: ${formData.skills}\nEducation: ${formData.education}\nAdditional: ${formData.additional}`
    );
    if (file) form.append("attachment", file);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/send-email`, {
        method: "POST",
        body: form,
      });
      const result = await response.json();
      setLoading(false); // 👈 Stop loader

      if (result.success) {
        amplitude.track("Job Application Submitted", {
          job_title: formData.jobTitle,
          has_resume: !!file,
        });
        setSuccessMessage("Your information was sent successfully!");
      } else {
        alert("Sending failed!");
      }
    } catch (error) {
      console.error("Error:", error);
      setLoading(false); // 👈 Stop loader
    }
  };

  return (
    <>

<Navbar />
<main className="main">
        <div className="video-container">
          <video autoPlay loop muted playsInline>
            <source
              src="https://cdn.pixabay.com/video/2020/08/12/46965-449623750_large.mp4"
              type="video/mp4"
            />
          </video>
        </div>
        {/* Hero Section */}
        <section className="hero">
          <div className="containerrr">
            <div className="text-center">
              <h1 className="hero-title">Careers</h1>
              <p className="hero-subtitle">
              Join our team of talented professionals and build a rewarding
              career with us.
              </p>
            </div>
          </div>
        </section>

        {/* Why Join Us */}
        <section className="wwwhy-join-section">
          <div className="wwcccontiner">
            <div className="wwcontent-wrapper">
              <div className="wwtext-content">
                <h2 className="wwsection-title">LIFE AT ITSOFTLAB</h2>
                <p className="wwsection-text">
                 
                </p>
                <p className="wwsection-text">
                  At IT Softlab, we believe that a great workplace is built on strong relationships, teamwork, and shared experiences.
                   Our recent outing to Nakhrali Dhani Water Park was a wonderful opportunity for team members to unwind, enjoy exciting activities, and create lasting memories beyond the office environment.
                </p>
                <p className="wwsection-text">
                The day was filled with fun, laughter, and moments of togetherness that strengthened team spirit and collaboration. 
                Such outings reflect our commitment to maintaining a positive work culture where employees can relax, connect, and grow together while enjoying a healthy work-life balance.
                </p>
              </div>
              <div className="wwimage-container">
                <div className="life-slider">
                  {lifeImages.map((src, index) => (
                    <img
                      key={index}
                      src={src}
                      alt={`Life at ITSoftlab ${index + 1}`}
                      className={`life-slide ${index === currentSlide ? "active" : ""}`}
                      onClick={() => setLightbox(src)}
                      style={{ cursor: "zoom-in" }}
                    />
                  ))}
                  <div className="life-slider-dots">
                    {lifeImages.map((_, index) => (
                      <button
                        key={index}
                        className={`life-dot ${index === currentSlide ? "active" : ""}`}
                        onClick={() => goToSlide(index)}
                        aria-label={`Go to slide ${index + 1}`}
                      />
                    ))}
                  </div>
                </div>
              </div>

              {/* Lightbox */}
              {lightbox && (
                <div className="lightbox-overlay" onClick={() => setLightbox(null)}>
                  <button className="lightbox-close" onClick={() => setLightbox(null)} aria-label="Close">✕</button>
                  <img
                    src={lightbox}
                    alt="Full view"
                    className="lightbox-img"
                    onClick={(e) => e.stopPropagation()}
                  />
                </div>
              )}
            </div>
          </div>
        </section>

        {/* Benefits */}

        {/* We're Hiring Section */}
        <section className="hiring-section">
          <div className="hiring-container">
            <div className="hiring-badge">
              <span className="hiring-badge-line"></span>
              JOB OPENING
              <span className="hiring-badge-line"></span>
            </div>
            <h2 className="hiring-main-title">Build the Future with ITSoftLab</h2>
            <p className="hiring-subtitle">
              We're growing our team and looking for passionate, talented and driven
              individuals to join us on our journey of innovation and excellence.
            </p>

            <h3 className="hiring-positions-title">Current Open Positions</h3>
            <div className="hiring-positions-divider"></div>

            <div className="hiring-cards-grid">
              {/* Card 1 */}
              <div className="hiring-card">
                <div className="hiring-card-header">
                  <div className="hiring-card-icon hiring-card-icon--blue">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                      <rect x="2" y="7" width="20" height="14" rx="2"/>
                      <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/>
                      <line x1="12" y1="12" x2="12" y2="16"/>
                      <line x1="10" y1="14" x2="14" y2="14"/>
                    </svg>
                  </div>
                  <div className="hiring-card-title-wrap">
                    <h4 className="hiring-card-title">Senior Business Development Executive (International Sales)</h4>
                  </div>
                  <span className="hiring-exp-badge hiring-exp-badge--blue">2–3+ Yrs</span>
                </div>
                <ul className="hiring-card-details">
                  <li><span className="hcd-icon">💼</span><strong>Experience:</strong>&nbsp;2–3+ Years</li>
                  <li><span className="hcd-icon">👤</span><strong>Role:</strong>&nbsp;International Sales / IT Services</li>
                  <li><span className="hcd-icon">🎯</span><strong>Focus:</strong>&nbsp;Lead Generation, Client Handling, Deal Closure</li>
                  <li><span className="hcd-icon">🔧</span><strong>Skills:</strong>&nbsp;Sales, Negotiation, Communication, CRM, LinkedIn, International Market</li>
                </ul>
                <button
                  className="hiring-view-btn hiring-view-btn--blue"
                  onClick={() => handleApplyClick("Senior Business Development Executive (International Sales)")}
                >
                  View Details &nbsp;→
                </button>
              </div>

              {/* Card 2 */}
              <div className="hiring-card">
                <div className="hiring-card-header">
                  <div className="hiring-card-icon hiring-card-icon--purple">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                      <polyline points="16 18 22 12 16 6"/>
                      <polyline points="8 6 2 12 8 18"/>
                    </svg>
                  </div>
                  <div className="hiring-card-title-wrap">
                    <h4 className="hiring-card-title">Senior MERN Stack Developer</h4>
                  </div>
                  <span className="hiring-exp-badge hiring-exp-badge--purple">2–3+ Yrs</span>
                </div>
                <ul className="hiring-card-details">
                  <li><span className="hcd-icon">💼</span><strong>Experience:</strong>&nbsp;2–3+ Years</li>
                  <li><span className="hcd-icon">👤</span><strong>Role:</strong>&nbsp;Full Stack Development</li>
                  <li><span className="hcd-icon">🎯</span><strong>Focus:</strong>&nbsp;Build scalable web applications using MERN stack</li>
                  <li><span className="hcd-icon">🔧</span><strong>Skills:</strong>&nbsp;MongoDB, Express.js, React.js, Node.js, JavaScript, APIs</li>
                </ul>
                <button
                  className="hiring-view-btn hiring-view-btn--purple"
                  onClick={() => handleApplyClick("Senior MERN Stack Developer")}
                >
                  View Details &nbsp;→
                </button>
              </div>

              {/* Card 3 */}
              <div className="hiring-card">
                <div className="hiring-card-header">
                  <div className="hiring-card-icon hiring-card-icon--green">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                      <path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
                    </svg>
                  </div>
                  <div className="hiring-card-title-wrap">
                    <h4 className="hiring-card-title">Senior Digital Marketing Executive (Performance Marketing & Lead Generation)</h4>
                  </div>
                  <span className="hiring-exp-badge hiring-exp-badge--green">1.5+ Yrs</span>
                </div>
                <ul className="hiring-card-details">
                  <li><span className="hcd-icon">💼</span><strong>Experience:</strong>&nbsp;1.5+ Years</li>
                  <li><span className="hcd-icon">👤</span><strong>Role:</strong>&nbsp;Performance Marketing & Lead Generation</li>
                  <li><span className="hcd-icon">🎯</span><strong>Focus:</strong>&nbsp;Paid Ads, Funnels, Lead Gen, Analytics & Optimization</li>
                  <li><span className="hcd-icon">🔧</span><strong>Skills:</strong>&nbsp;Google Ads, Meta Ads, GA4, GTM, Landing Pages, SEO Basics</li>
                </ul>
                <button
                  className="hiring-view-btn hiring-view-btn--green"
                  onClick={() => handleApplyClick("Senior Digital Marketing Executive (Performance Marketing & Lead Generation)")}
                >
                  View Details &nbsp;→
                </button>
              </div>
            </div>

            {/* Info Bar */}
            <div className="hiring-info-bar">
              <div className="hiring-info-item">
                <span className="hiring-info-icon">📍</span>
                <div>
                  <strong>Location</strong>
                  <p>651-A, Mahalaxmi Nagar,<br />Indore, Madhya Pradesh</p>
                </div>
              </div>
              <div className="hiring-info-item">
                <span className="hiring-info-icon">🏢</span>
                <div>
                  <strong>Work Mode</strong>
                  <p>Work From Office</p>
                </div>
              </div>
              <div className="hiring-info-item">
                <span className="hiring-info-icon">📅</span>
                <div>
                  <strong>Working Days</strong>
                  <p>Monday – Friday<br />(5 Days a Week)</p>
                </div>
              </div>
              <div className="hiring-info-item">
                <span className="hiring-info-icon">💼</span>
                <div>
                  <strong>Employment Type</strong>
                  <p>Full-Time | Permanent</p>
                </div>
              </div>
            </div>
          </div>
        </section>



        <div className="resume-resume-form-container" id="resume-form-section">
        <div className="resume-form-container">
      <h1>Submit Your Resume</h1>
      <form onSubmit={handleSubmit}>
        <div className="grid">
          <input
            name="firstName"
            type="text"
            placeholder="First Name"
            value={formData.firstName}
            onChange={handleChange}
            required
          />
          <input
            name="lastName"
            type="text"
            placeholder="Last Name"
            value={formData.lastName}
            onChange={handleChange}
            required
          />
        </div>

        <div className="grid">
          <input
            name="email"
            type="email"
            placeholder="Email Address"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <input
            name="phone"
            type="text"
            placeholder="Phone Number"
            value={formData.phone}
            onChange={handleChange}
            required
          />
        </div>

        <input
          name="jobTitle"
          type="text"
          placeholder="Job Title"
          value={formData.jobTitle}
          onChange={handleChange}
          required
        />
        <input
          name="experience"
          type="text"
          placeholder="Years of Experience"
          value={formData.experience}
          onChange={handleChange}
          required
        />
        <textarea
          name="skills"
          placeholder="Skills"
          value={formData.skills}
          onChange={handleChange}
          required
        />
        <textarea
          name="education"
          placeholder="Education"
          value={formData.education}
          onChange={handleChange}
          required
        />
        <textarea
          name="additional"
          placeholder="Additional Info"
          value={formData.additional}
          onChange={handleChange}
        />

        <label>Upload Resume (PDF):</label>
        <input type="file" accept="application/pdf" onChange={handleFileChange} />

        <button type="submit">Submit</button>
        {message && <p className="message">{message}</p>}
      </form>
       {/* Full-screen loader popup */}
       {loading && (
        <div className="loader-overlay">
          <div className="loader-popup"></div>
        </div>
      )}

      {successMessage && <p>{successMessage}</p>}
    </div>
    </div>





        {/* Application Process */}
        {/* <section class="aaaapplication-process">
          <div class="aaaccconntainer">
            <div class="aaasection-header">
              <h2 class="aaasectionn-title">Our Application Process</h2>
              <div class="aaasection-divider"></div>
            </div>

            <div class="aaaprocess-steps">
              <div class="aaasteps-container">
                <div class="aaastep" id="step-1">
                  <div class="aaastep-icon">1</div>
                  <div class="aaastep-content">
                    <h3 class="aaastep-title">Application Review</h3>
                    <p class="aaastep-description">
                      We review all applications and select candidates whose
                      qualifications match our requirements.
                    </p>
                  </div>
                </div>

                <div class="aaastep" id="step-2">
                  <div class="aaastep-icon">2</div>
                  <div class="aaastep-content">
                    <h3 class="aaastep-title">L1-Interview</h3>
                    <p class="aaastep-description">
                      Selected candidates are invited for an initial interview
                      to discuss their experience and our expectations.
                    </p>
                  </div>
                </div>

                <div class="aaastep" id="step-3">
                  <div class="aaastep-icon">3</div>
                  <div class="aaastep-content">
                    <h3 class="aaastep-title">L2-Skills Assessment</h3>
                    <p class="aaastep-description">
                      Candidates may be asked to complete a skills assessment
                      relevant to the position.
                    </p>
                  </div>
                </div>

                <div class="aaastep" id="step-4">
                  <div class="aaastep-icon">4</div>
                  <div class="aaastep-content">
                    <h3 class="aaastep-title">L3-Interview</h3>
                    <p class="aaastep-description">
                    Shortlisted candidates meet with senior team members to assess technical depth and cultural fit.
                    </p>
                  </div>
                </div>

                <div class="aaastep" id="step-4">
                  <div class="aaastep-icon">5</div>
                  <div class="aaastep-content">
                    <h3 class="aaastep-title">L4-Final Interview</h3>
                    <p class="aaastep-description">
                      Final candidates meet with the hiring manager and team
                      members for a more in-depth discussion.
                    </p>
                  </div>
                </div>

                <div class="aaastep" id="step-5">
                  <div class="aaastep-icon">6</div>
                  <div class="aaastep-content">
                    <h3 class="aaastep-title">Release-Offer Letter</h3>
                    <p class="aaastep-description">
                      Successful candidates receive a job offer with details
                      about compensation and benefits.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}

        <section class="cctta-section">
          <div class="contatainer text-center">
            <h2 class="cctta-title">Don't See the Right Position?</h2>
            <p class="cctta-text">
              We're always looking for talented individuals to join our team.
              Send us your resume, and we'll keep you in mind for future
              opportunities.
            </p>
            <a href="/contactus" class="cctta-button">
              Contact Us
            </a>
          </div>
        </section>
       
      </main>
    </>
  );
}
